import type { FC } from 'react';
import { Box, Chip } from '@mui/material';
import Select, { type Option, type SelectProps } from './Select';
import { MARKETING_PROCESS, MarketingProcessCode } from '../../constants';


interface Process {
  name: string;
  code: string;
}

type SelectMarketingProcessProps = Partial<Pick<SelectProps, 'handleChange' | 'name' | 'inputLabel'>>;

const SelectMarketingProcess: FC<SelectMarketingProcessProps> =
  ({
     handleChange,
     name,
     inputLabel,
   }) => {
    const listMapper = ({ name, code }: Process) => ({
      label: name,
      value: code,
    });

    const renderOption = (option: Option) => (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {option.label}
        {option.value === MarketingProcessCode.HYPOTHESIS_TESTING && (
          <Chip
            label="beta"
            size="small"
            sx={{
              height: 18,
              fontSize: 'typography.caption.fontSize',
              fontWeight: 500,
              textTransform: 'lowercase',
              color: 'common.white',
              '&.MuiChip-root': {
                backgroundColor: 'rgb(147,94,255)',
              },
              '& .MuiChip-label': { px: 0.75 },
            }}
          />
        )}
      </Box>
    );

    return (
      <Select
        name={name ?? 'marketingProcess'}
        inputLabel={inputLabel ?? 'Marketing Process'}
        options={MARKETING_PROCESS.map(listMapper)}
        handleChange={handleChange}
        renderOption={renderOption}
      />
    );
  };

export default SelectMarketingProcess;
